import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mascotImage from '../../../images/mascot/mascot@2x.png';

export default class EmptyListUi extends Component {
  static propTypes = {
    filtersAreApplied: PropTypes.bool,
    isCurrentJobsList: PropTypes.bool,
    isWorkerDetails: PropTypes.bool,
    navigateToCreateJob: PropTypes.func
  };

  _renderTitle = () => {
    const { isCurrentJobsList, filtersAreApplied } = this.props;
    const title = filtersAreApplied ? 'No Jobs Found' : isCurrentJobsList ? 'No Current Jobs'
      : isCurrentJobsList === false ? 'No Past Jobs' : 'No Jobs Found';
    return (
      <h2 className='title'>{ title }</h2>
    );
  };

  render () {
    const { filtersAreApplied, isCurrentJobsList, navigateToCreateJob, isWorkerDetails } = this.props;
    const showPostJobButton = (!filtersAreApplied && isCurrentJobsList && !isWorkerDetails);
    return (
      <div className='empty-list-wrapper text-center mt-5'>
        <img className='mascot-image' src={mascotImage} alt='mascot' />
        { this._renderTitle() }
        { filtersAreApplied && <p className='info-text'>Try to specify different filter criteria</p> }
        { showPostJobButton && (
          <React.Fragment>
            <p className='info-text'>Post a Job To Get Started</p>
            <button
              className='button button-primary button-wide'
              onClick={navigateToCreateJob}
            >Post a Job</button>
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobsList/EmptyListUi.js